import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  > span {
    background-color: #f5f5f5;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    padding: 4.5px 8px;
    color: #363636;
    font-size: 14px;
    svg {
      height: 12px;
      margin-right: 6px;
      margin-bottom: 1px;
    }
  }
  button {
    display: none;
    color: #0085ff;
    border: none;
    box-shadow: none;
    font-weight: 700;
    padding: 0px 8px;
    border-radius: 8px;
    margin-left: 16px;
    svg {
      margin-right: 6px;
    }
  }
  button + button {
    display: initial;
    background-color: #e7f3fe;
    &:hover {
      background-color: #dceefe;
      color: #0085ff;
    }
  }
`
